import React from 'react';
import { Link } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import dhartiNetraLogo from '../../images/dhartinetralogo.png';
import useDashboardAuth from '../../hooks/useDashboardAuth';
import './Header.css';

const Header = () => {
  const { logout, user } = useDashboardAuth();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      window.location.reload();
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src={dhartiNetraLogo} alt="DhartiNetra" className="header-logo" />
          </Link>
          <nav className="nav">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link">Dashboard</Link>
              </li>
              {user && (
                <li className="nav-item user-info">
                  <span className="user-name">Welcome, {user.username}</span>
                </li>
              )}
              <li className="nav-item">
                <button onClick={handleLogout} className="logout-button">
                  <FaSignOutAlt />
                  Logout
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
